import { render } from "./ReportCrudView.vue?vue&type=template&id=41c93d64&scoped=true"
import script from "./ReportCrudView.vue?vue&type=script&lang=js"
export * from "./ReportCrudView.vue?vue&type=script&lang=js"

import "./ReportCrudView.vue?vue&type=style&index=0&id=41c93d64&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c93d64"]])

export default __exports__